var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('coozzy-card',{attrs:{"title":_vm.$t('message.settings.template.titleContract')}},[_c('template-table',{attrs:{"source":'setting'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }